export const BRAND_NAME = 'BelaHora';
export const BRAND_LOCKUP_PATH = '/belahora-mark-150.svg';
export const BRAND_LOCKUP_COMPACT_PATH = '/belahora-mark-40.svg';
export const BRAND_SYMBOL_PATH = '/belahora-symbol.svg';
export const BRAND_APP_ICON_PATH = '/logo512.png';
export const BRAND_OG_IMAGE_PATH = '/og-image.png';
export const BRAND_STRUCTURED_DATA_LOGO_PATH = BRAND_LOCKUP_PATH;

export function buildPublicAssetPath(path: string) {
  const publicUrl = process.env.PUBLIC_URL ?? '';

  return `${publicUrl}${path}`;
}
